import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const MosaferatiApiPaths: IPaths = {
  BimehNameh: {
    Estelam: 'BimehNameh/EstelamGharardadSafar',
    PrintBimehNamehMosaferati: 'BimehNameh/PrintBimehNamehMosaferati',
    GetMosaferatiShomarehBimehNamehHa: 'BimehNameh/GetMosaferatiShomarehBimehNamehHa',
    GetMosaferatiBimehNamehHaPagedFilter: 'BimehNameh/GetMosaferatiBimehNamehHaPagedFilter',
    GetPrintBimehNamehMosaferatiDisplay: 'BimehNameh/GetPrintBimehNamehMosaferatiDisplay',
    GetMosaferatiBimehNamehByShomarehBimehNameh: 'BimehNameh/GetMosaferatiBimehNamehByShomarehBimehNameh',
    AddBimehNamehMosaferatiToOrder: 'BimehNameh/AddBimehNamehMosaferatiToOrderWepod',
    CreateShenasehPardakht: 'BimehNameh/CreateShenasehPardakht',
    BimehNamehMosaferatiSaderShodeh: 'BimehNameh/BimehNamehMosaferatiSaderShodeh',
    GetElhaghiyehHayeSadereh: 'BimehNameh/GetElhaghiyehHayeSadereh',
    PrintElhaghiyehMosaferati: 'BimehNameh/PrintElhaghiyehMosaferati',
    PrintBimehNamehMosaferatiById: 'BimehNameh/PrintBimehNamehMosaferatiById',
  },
  DestinationCountry: {
    GetCountries: 'DestinationCountry/GetCountries',
  },
  TarhSafar: {
    GetActiveTarhHayeSafarByNoeGharardadSafarCoreIdAndCountryCoreId:
      'TarhSafar/GetActiveTarhHayeSafarByNoeGharardadSafarCoreIdAndCountryCoreId',
    GetNoeGharardadSafarByCountryCoreId: 'TarhSafar/GetNoeGharardadSafarByCountryCoreId',
  },
  NoeGharardadSafar: {
    GetNoeGharardadSafarCountryByCountryCoreId: 'NoeGharardadSafar/GetNoeGharardadSafarCountryByCountryCoreId',
    GetNerkhNoeGharardadSafarByNoeGharardadSafarCoreId:
      'NoeGharardadSafar/GetNerkhNoeGharardadSafarByNoeGharardadSafarCoreId',
  },
};
